import { ContentCopyRounded, MailOutlineRounded } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../components/ui/Button";
import IconButton from "../../components/ui/IconButton";
import Modal from "../../components/ui/Modal";
import Toast from "../../components/ui/Toast";
import { auth } from "../../configurations/firebaseConfig";
import styles from "./css/ContactUsModal.module.css";

const contactEmail = "zak1ller.kr@gmail.com";
const contactSubject = "Onevoca Web Version";

interface ContactUsModalProps {
  open: boolean;
  onClose: () => void;
}

// 메일 앱이 없는 유저도 문의할 수 있도록 주소 복사 · Gmail 웹 작성을 함께 제공한다.
// mailto 는 메일 앱이 열렸는지 알 수 없어서 실패 시 대체 동작을 붙일 수 없다.
export default function ContactUsModal(props: ContactUsModalProps) {
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const uid = auth.currentUser?.providerData[0]?.uid;
  const body = uid ? `Onevoca ID: ${uid}\n\n` : "";

  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setToastMessage(t("ContactUsCopied"));
    } catch {
      setToastMessage(t("ContactUsCopyFailed"));
    }
  }

  function handleOnClickMailAppButton() {
    window.location.href = `mailto:${contactEmail}?subject=${encodeURIComponent(
      contactSubject
    )}&body=${encodeURIComponent(body)}`;
  }

  function handleOnClickGmailButton() {
    const params = new URLSearchParams({
      view: "cm",
      fs: "1",
      to: contactEmail,
      su: contactSubject,
      body,
    });
    window.open(
      `https://mail.google.com/mail/?${params.toString()}`,
      "_blank",
      "noopener"
    );
  }

  return (
    <>
      <Modal
        open={props.open}
        onClose={props.onClose}
        title={t("ContactUs")}
        description={t("ContactUsDescription")}
        size="sm"
        showCloseButton
        closeLabel={t("CloseButton")}
        footer={
          <div className={styles.actions}>
            <Button
              size="lg"
              fullWidth
              leadingIcon={<MailOutlineRounded />}
              onClick={handleOnClickMailAppButton}
            >
              {t("ContactUsOpenMailApp")}
            </Button>
            <Button
              size="lg"
              variant="secondary"
              fullWidth
              onClick={handleOnClickGmailButton}
            >
              {t("ContactUsWriteInGmail")}
            </Button>
          </div>
        }
      >
        <div className={styles.rows}>
          <div className={styles.row}>
            <div className={styles.rowText}>
              <span className={styles.label}>{t("ContactUsEmailLabel")}</span>
              <span className={styles.value}>{contactEmail}</span>
            </div>
            <IconButton
              aria-label={t("ContactUsCopyEmail")}
              icon={<ContentCopyRounded />}
              variant="ghost"
              size="sm"
              onClick={() => copy(contactEmail)}
            />
          </div>
          {uid && (
            <div className={styles.row}>
              <div className={styles.rowText}>
                <span className={styles.label}>Onevoca ID</span>
                <span className={styles.value}>{uid}</span>
              </div>
              <IconButton
                aria-label={t("ContactUsCopyId")}
                icon={<ContentCopyRounded />}
                variant="ghost"
                size="sm"
                onClick={() => copy(uid)}
              />
            </div>
          )}
        </div>
      </Modal>
      <Toast
        open={toastMessage !== null}
        onClose={() => setToastMessage(null)}
        message={toastMessage}
      />
    </>
  );
}
